import type { KensukeFeatureCardDef } from '../constants/kensukeFeatureCards';

/** 利用人気（直近30日・page_view。直リン含む。home / dashboard で同一順序）。同点は homeOrder。 */
export function sortKensukeFeatureCardsByPopularity(
  cards: KensukeFeatureCardDef[],
  rankCounts: Record<string, number>
): KensukeFeatureCardDef[] {
  return [...cards].sort((a, b) => {
    const countA = rankCounts[a.id] ?? 0;
    const countB = rankCounts[b.id] ?? 0;
    if (countB !== countA) {
      return countB - countA;
    }
    return a.homeOrder - b.homeOrder;
  });
}

export function featureEntranceRankMap(
  ranks: Array<{ featureId: string; count: number }>
): Record<string, number> {
  const map: Record<string, number> = {};
  for (const row of ranks) {
    map[row.featureId] = row.count;
  }
  return map;
}
